
















































































































































import { sleep } from '@ivy/fts/utils'
import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import TopBar from '@/components/TopBar.vue'
import FollowModel from '@/pages/goods-new/comps/FollowModel.vue'
import ShareModel from '@/pages/goods-new/comps/ShareModel.vue'
import ToDistributorModel from './ToDistributorModel.vue'
import * as weixin from '@ivy/fts/weixin'
import { uploadEvent } from '@/api/goods/statistics'

@Component({
  components: {
    TopBar,
    FollowModel,
    ShareModel,
    ToDistributorModel,
  },
})
export default class Warmup extends Vue {
  listen: any = null
  navbarHeight: number = 25
  isLoading: boolean = true
  limitTime: any = []
  limitTimeStr: any = ''
  data: any = {}
  distributor: any = {}
  otherData: any = {}
  timer: any = null
  share_img_url: string = ''
  showShare: boolean = false
  showFollow: boolean = false
  showDist: boolean = false
  limitData: any = {}
  options: any = null
  curLevel: any = {}
  cashCount: string = ''
  get isApp() {
    return env.type === 'ivydad'
  }
  get needShowNav() {
    return true
  }
  get bgColor() {
    return {
      background: this.data.bgColor ? this.data.bgColor : '#fff6e7',
    }
  }
  get getDay() {
    let day = this.limitTime[0]
    if (day === '00' || !day) {
      return ''
    } else {
      return Number(day) + '天'
    }
  }
  get limitTimeFilter() {
    return this.limitTime.splice(-3) || []
  }

  get getCoin() {
    return v => {
      v = Number(v)
      if (!Number.isInteger(v)) {
        v = v.toFixed(2).toString()
      }
      return v || 0
    }
  }
  // 判断活动时间是否开始
  get judgeStartTime() {
    return time => {
      if (time && Date.now() < new Date(time).getTime()) {
        return true
      }
      return false
    }
  }

  // 判断活动时间是否结束
  get judgeEndTime() {
    return end => {
      if (end && Date.now() > new Date(end).getTime()) {
        return true
      }
      return false
    }
  }

  // 是否活动中
  get isComing() {
    let end = (this.data.endTime || '').replace(/-/g, '/')
    let start = (this.data.beginTime || '').replace(/-/g, '/')
    return !this.judgeStartTime(start) && !this.judgeEndTime(end)
  }

  async created() {
    await env.init()
    await this.getInfo()
    this.getRewardMoney()
    await uploadEvent.init()
    if (this.isComing) {
      uploadEvent.sendRecord(
        'Exposure_Scholarship',
        '',
        {
          Time: new Date().format('YYYY-MM-DD hh:mm:ss'),
        },
        [['p1', 'Time']]
      )
    }
  }

  async getInfo() {
    let { data } = await this.$axios.get(
      '/api/goods/shop/market/scholarshipDistribution/getDistributionActivityInfo',
      {
        params: {
          scholarship_distribution_id: this.$route.query
            .scholarship_distribution_id,
        },
      }
    )
    this.data = data
    this.distributor = data.distributor || {}
    this.$title(data.posterName || '常青藤爸爸')
    this.setShare()
    this.countdown()
  }

  async getRewardMoney() {
    let { data } = await this.$axios.get('/api/mobile/user/account/balance', {
      params: {
        type: 'cash',
      },
    })
    this.cashCount = this.getCoin(data)
  }
  mounted() {
    document.addEventListener('visibilitychange', this.visibilityChange)
  }
  async visibilityChange() {
    var isHidden = document.hidden
    console.log('isHidden', isHidden)
    // if (isHidden) {

    // } else {

    // }
  }

  async destroyed() {
    document.removeEventListener('visibilitychange', this.visibilityChange)
  }
  async setShare() {
    let { data } = await this.$axios.get(
      '/api/goods/shop/market/scholarshipDistribution/getText',
      {
        params: {
          type: 'share',
        },
      }
    )
    console.log('rrrrr', data)
    let _options = {
      title: data.title,
      desc: data.desc,
      imgUrl: data.imgUrl,
      link: data.link || encodeURI(window.location.href),
    }

    // 传给 app 分享
    this.options = {
      title: data.title,
      content: data.desc,
      url: data.link || window.location.href,
      pic_url: data.imgUrl,
    }

    env.type === 'wx' && (await weixin.weixinShare(_options))
  }

  async goGoods(item) {
    this.isComing &&
      (await uploadEvent.sendRecord(
        'Click_Scholarship_GoodsDetail',
        '',
        {
          GoodsName: item.title,
          SkuID: item.skuId,
        },
        [
          ['p1', 'GoodsName'],
          ['p2', 'SkuID'],
        ]
      ))
    this.$router.push({
      path: '/goodsView',
      query: {
        spuId: item.spuId,
        selectSkuId: item.skuId,
        distributorMemId: this.$route.query.distributorMemId || '',
      },
    })
  }

  async getScholarshipDetail() {
    await env.init()
    if (await env.getIsLogin()) {
      let userInfo = await env.getInfo()
      let memId = null
      if (env.type === 'ivydad') {
        memId = userInfo.userInfo.memId
      } else {
        memId = userInfo.logined.user.id
      }
      if (memId) {
        let { data } = await this.$axios.get(
          '/api/goods/shop/market/scholarshipDistribution/getScholarshipDetail',
          {
            params: {
              memId,
            },
          }
        )
        this.otherData = data
      }
    }
  }

  async countdown() {
    let end = (this.data.endTime || '').replace(/-/g, '/')
    let start = (this.data.beginTime || '').replace(/-/g, '/')
    // 当前时间小于开始时间
    if (this.judgeStartTime(start)) {
      this.limitTimeStr = '活动还未开始'
      this.limitTime = []
      return
    }
    // 当前时间大于结束时间
    if (this.judgeEndTime(end)) {
      this.limitTimeStr = '活动已结束'
      this.limitTime = []
      return
    }
    const self = this
    async function clock(end) {
      let msec = new Date(end).getTime() - new Date().getTime()
      // 倒计时没有了，刷新页面
      if (msec < 0) {
        if (self.timer) {
          clearInterval(self.timer)
        }
        await sleep(200)
        self.getInfo()
      } else {
        let remainTime = Date.formatMs(msec, 'DD hh mm ss')
        self.limitTimeStr = '距结束'
        self.limitTime = remainTime.split(' ')
      }
    }
    if (this.timer) {
      clearInterval(this.timer)
    }
    clock(end)
    this.timer = setInterval(() => {
      clock(end)
    }, 1000)
  }
  async goShare(item) {
    if (this.judgeStartTime(this.data.beginTime)) {
      return this.$Toast('未开始，不生成海报。')
    }
    await env.init()
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }

    let loginfo = (await env.getInfo()) || {}
    let logined = loginfo.logined || {}
    let user = logined.user || {}

    console.log('ffff', loginfo)
    // 埋点，统计分销
    this.$axios.post(
      '/api/goods/shop/market/scholarshipDistribution/recordDistributionStatistics',
      {
        scholarship_distribution_id: item.distributionActivityId,
        scholarship_distributor_id: user.id,
        sku_id: item.skuId,
        type: 'share',
        sku_type: 1,
        customer_wx_unionid: logined.unionid,
        customer_wx_avatar: logined.headimgurl,
        customer_wx_nickname: logined.nickname,
      },
      {
        disableAlert: true,
      }
    )

    this.isComing &&
      uploadEvent.sendRecord(
        'Click_Scholarship_ShareButton',
        '',
        {
          PageName: '分销奖学金活动页',
          SkuID: item.skuId,
        },
        [
          ['p1', 'PageName'],
          ['p2', 'SkuID'],
        ]
      )
    this.curLevel = item
    // 如果是分销员
    if (this.data.distributor && this.data.distributor.id) {
      let { data } = await this.$axios.post(
        '/api/goods/shop/market/scholarshipDistribution/shareDistribution',
        {
          scholarship_distribution_id: item.distributionActivityId,
          sku_id: item.skuId,
          distributorMemId: this.$route.query.distributorMemId || '',
        }
      )

      this.share_img_url = data.poster_url
      this.showShare = true
    } else {
      let { data } = await this.$axios.get(
        '/api/goods/shop/market/scholarshipDistribution/getText',
        {
          params: {
            type: 'limit',
            distributorMemId: this.$route.query.distributorMemId || '',
          },
        }
      )
      this.limitData = data
      this.showDist = true
    }
  }
  async shareSuccess() {
    let localId = window.localStorage.getItem('__ActivityId')
    let localTime = window.localStorage.getItem('__ActivityIdTime')

    let dayActivity =
      '' + new Date().getDay() + this.curLevel.distributionActivityId

    console.log(
      '----',
      localId,
      localTime,
      this.curLevel.distributionActivityId,
      dayActivity
    )
    // 该活动没有不在梯形且当天该活动没有弹过
    if (
      +localId != this.curLevel.distributionActivityId &&
      localTime != dayActivity
    ) {
      window.localStorage.setItem(
        '__ActivityIdTime',
        '' + new Date().getDay() + this.curLevel.distributionActivityId
      )
      let { data } = await this.$axios.get(
        '/api/goods/shop/market/scholarshipDistribution/judgePopSubWindow'
      )

      console.log('ddd', data)
      if (data) {
        this.showFollow = true
      }
    }
  }
  async login() {
    await env.init()
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }
  }
  async goDetail() {
    await this.login()
    this.isComing &&
      (await uploadEvent.sendRecord(
        'Click_Scholarship_Income Details',
        '',
        {
          PageName: '分销奖学金活动页',
        },
        [['p1', 'PageName']]
      ))

    if (env.type === 'ivydad') {
      let url = `${window.location.origin}/center/distribute/rewardIncome`
      env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}`)
    } else {
      window.location.href = `${window.location.origin}/center/distribute/rewardIncome`
    }
  }

  async goVisit() {
    await this.login()
    if (env.type === 'ivydad') {
      let url = `${window.location.origin}/center/distribute/myCustomer?type=visit`
      env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}`)
    } else {
      window.location.href = `${window.location.origin}/center/distribute/myCustomer?type=visit`
    }
  }
  async goOrder() {
    await this.login()
    if (env.type === 'ivydad') {
      let url = `${window.location.origin}/center/distribute/quickCashOrderList`
      env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}`)
    } else {
      window.location.href = `${window.location.origin}/center/distribute/quickCashOrderList`
    }
  }
  async goReady() {
    await this.login()
    if (env.type === 'ivydad') {
      let url = `${window.location.origin}/center/distribute/myCustomer?type=ready`
      env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}`)
    } else {
      window.location.href = `${window.location.origin}/center/distribute/myCustomer?type=ready`
    }
  }
}
